var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocumentCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.167 11.1666V13.6666C14.167 17 12.8337 18.3333 9.50033 18.3333H6.33366C3.00033 18.3333 1.66699 17 1.66699 13.6666V10.5C1.66699 7.16663 3.00033 5.83329 6.33366 5.83329H8.83366M14.167 11.1666H11.5003C9.50033 11.1666 8.83366 10.5 8.83366 8.49996V5.83329M14.167 11.1666L8.83366 5.83329M9.66699 1.66663H13.0003M5.83366 4.16663C5.83366 2.78329 6.95033 1.66663 8.33366 1.66663H10.517M18.3337 6.66663V11.825C18.3337 13.1166 17.2837 14.1666 15.992 14.1666M18.3337 6.66663H15.8337C13.9587 6.66663 13.3337 6.04163 13.3337 4.16663V1.66663L18.3337 6.66663Z",
    stroke: "#BABABA",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentCopy);
export default __webpack_public_path__ + "static/media/document-copy.81b392ef99903a6b0ff33e62be409aa5.svg";
export { ForwardRef as ReactComponent };